import {LOCATE_HIDE_MENU} from "../types";

const hideAllMenu = (visible) => {
  return ({type: LOCATE_HIDE_MENU, payload: {hideAllMenu: visible}});
};

export default hideAllMenu;